import { motion } from 'framer-motion';
import type { BioProfile } from '../data/profile';

type BioHeaderProps = {
  profile: BioProfile;
};

export function BioHeader({ profile }: BioHeaderProps) {
  return (
    <header className="bio-header">
      <motion.div
        className="bio-logo-wrap"
        initial={{ opacity: 0, y: 12, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <img src={profile.logo} alt={`Logo ${profile.name}`} className="bio-logo" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: 'easeOut', delay: 0.08 }}
      >
        <h1>{profile.name}</h1>
        <p>{profile.description}</p>
      </motion.div>
    </header>
  );
}
